import React from "react"
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material"
import AddLinesInput from "./AddLinesInput"
import AddLinesMap from "./AddLinesMap"
import { useMutation } from "@apollo/client"
import { ADD_GROWING_LINES } from "../../../gql/growing_lines"

export default function AddFarmLinesIndex({
  open,
  setAddingLines,
  activeAreaId,
  initialCenter,
  growingLinesGeoJSON,
  farmAreaGeoJSON,
}) {
  const activeAreaLines = {
    ...growingLinesGeoJSON,
    features: [
      ...growingLinesGeoJSON?.features?.filter(
        (l) => l?.properties?.area_id === activeAreaId
      ),
    ],
  }

  const [lines, setLines] = React.useState(activeAreaLines)
  const [addingMode, setAddingMode] = React.useState("map")
  const [addGrowingLines] = useMutation(ADD_GROWING_LINES)

  // use effect to update the lines if the active area changes
  React.useEffect(() => {
    setLines(activeAreaLines)
    // eslint-disable-next-line
  }, [activeAreaId])

  const handleSaveLines = () => {
    addGrowingLines({
      variables: {
        growingLines: [
          ...lines.features
            .filter((l) => !l.id)
            .filter((l) => l.geometry.coordinates.length === 2)
            .map((line) => ({
              area_id: activeAreaId,
              type: "growing_line",
              name: line.properties?.name || `Growing Line`,
              geo_json: {
                type: "LineString",
                coordinates: line.geometry.coordinates,
              },
              metadata: {},
            })),
        ],
      },
    })
    setAddingLines(false)
  }

  const handleModeChange = (event, newMode) => {
    setAddingMode(newMode)
  }

  const activeAreaGeoJson = {
    ...farmAreaGeoJSON,
    features: [
      ...farmAreaGeoJSON.features.filter((area) => area.id === activeAreaId),
    ],
  }

  return (
    <Dialog open={open} fullWidth maxWidth="lg">
      <DialogTitle>Add lines to a farm area</DialogTitle>
      <DialogContent>
        <ToggleButtonGroup
          value={addingMode}
          onChange={handleModeChange}
          exclusive
        >
          <ToggleButton value="map">Map Input</ToggleButton>
          <ToggleButton value="input">Text Input</ToggleButton>
        </ToggleButtonGroup>
        {addingMode === "input" && <AddLinesInput />}
        {addingMode === "map" && (
          <AddLinesMap
            initialCenter={initialCenter}
            lines={lines}
            setLines={setLines}
            growingLinesGeoJSON={growingLinesGeoJSON}
            activeAreaGeoJson={activeAreaGeoJson}
          />
        )}
        Adding Lines to area: {activeAreaId}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setAddingLines(false)
          }}
        >
          Discard Changes
        </Button>

        <Button onClick={handleSaveLines}>Save Changes</Button>
      </DialogActions>
    </Dialog>
  )
}
